import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getShipmentsEvolution,
    getShipmentsProviders,
    getShipmentsStates,
    getShipmentsMonths,
    getChargesMonths,
    getChargesRefundsMonths,
    getChargesUsers,
    getOverweightMonths,
    getEventsFunnel,
}

function getShipmentsEvolution(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/graphics/shipments/evolution`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsProviders(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/graphics/shipments/providers`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsStates(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60
        Superagent
            .get(`${HOST_API}/graphics/shipments/states`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsMonths(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/graphics/shipments/months`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getChargesMonths(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/graphics/charges/months`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getChargesRefundsMonths(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/graphics/charges/refunds/months`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getOverweightMonths(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/graphics/overweights/months`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res?.body || { success: false })
            })
    })
}

function getChargesUsers(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/graphics/charges/users`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res?.body || { success: false })
            })
    })
}

function getEventsFunnel(query) {
    return new Promise((resolve) => {
        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/graphics/events/funnel`)
            .set('access', Storage.getItem('access'))
            .query({ admin: true, timezone, ...query })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}
